<template>
    <div style="white-space: nowrap;">
        R$ {{ formatPrice(valor) }}<span class="text--secondary">{{ anual ? '/ano' : '/mês' }}</span>
        <div v-if="anual" class="caption text--secondary">R$ {{ formatPrice(valor / 12) }}/mês</div>
    </div>
</template>

<script>
export default {
    name: 'ValorPlano',

    props: {
        valor: {
            type: [String, Number],
            required: true,
        },
        periodicidade: {
            type: String,
            default: 'mensal',
        },
    },

    computed: {
        anual() {
            return this.periodicidade === 'anual';
        },
    },
}
</script>
